{
  "editor": {
    "headingNew": "Ny anteckning",
    "headingAmend": "Rätta anteckningen",
    "noteType": "Anteckningstyp",
    "sign": "Signera",
    "signing": "Signerar…",
    "cancel": "Avbryt",
    "close": "Stäng",
    "nothingSaved": "Ingenting sparas förrän du signerar. Det finns inget utkast — lämnar du skärmen är texten borta.",
    "amendExplanation": "Rättelsen blir version {version}. Den nuvarande versionen tas inte bort utan står kvar i journalen.",
    "signedIrreversible": "En signerad anteckning kan inte tas bort. Fel rättas genom en ny version.",
    "discardQuestion": "Stäng anteckningen? Texten du har skrivit sparas inte.",
    "discardConfirm": "Stäng utan att spara",
    "discardCancel": "Fortsätt skriva",
    "signedOk": "Anteckningen är signerad och finns i journalen.",
    "amendedOk": "Rättelsen är signerad som version {version}. Den tidigare versionen står kvar i journalen.",
    "reload": "Läs om anteckningen",
    "language": "Anteckningens språk",
    "languageChoose": "Välj språk …"
  },
  "action": {
    "write": "Skriv en anteckning",
    "amend": "Rätta anteckningen",
    "showVersions": "Visa alla versioner",
    "hideVersions": "Dölj versioner"
  },
  "history": {
    "heading": "Versioner",
    "loading": "Läser versioner…",
    "failed": "Versionerna kunde inte läsas.",
    "notFound": "Anteckningen finns inte i journalen.",
    "retry": "Försök igen",
    "count": "{count, plural, one {# version} other {# versioner}}",
    "current": "Nuvarande version",
    "superseded": "Ersatt av en senare version"
  },
  "version": {
    "number": "Version {version}",
    "written": "Skriven i journalen {time}",
    "signedBy": "Signerad av {name}, {time}",
    "signedByWithTitle": "Signerad av {title} {name}, {time}",
    "unsigned": "Inte signerad",
    "retracted": "Markerad som felaktigt införd",
    "clock": "Klocka: {source}",
    "clockWithUncertainty": "Klocka: {source}, angiven noggrannhet ±{seconds} s",
    "empty": "Den här versionen har ingen text."
  },
  "clock": {
    "gps": "GPS",
    "ntp": "Tidsserver",
    "rtc": "Lådans egen klocka",
    "manual": "Ställd för hand"
  },
  "field": {
    "bodyText": "Löpande text"
  },
  "fieldHint": {
    "subjective": "Vad patienten berättar.",
    "objective": "Undersökningsfynd och mätvärden.",
    "assessment": "Din bedömning.",
    "plan": "Fortsatt handläggning.",
    "bodyText": "För det som inte passar i SOAP-fälten. Fyll i SOAP-fälten, löpande text eller båda."
  },
  "refusal": {
    "empty": "Anteckningen är tom. Skriv i minst ett fält innan du signerar.",
    "typeMissing": "Välj en anteckningstyp.",
    "typeInvalid": "Anteckningstypen godtas inte. Välj en av typerna i listan.",
    "fieldTooLong": "{field} är för lång. Korta ner till högst {maximum} tecken.",
    "languageInvalid": "Språkkoden godtas inte. Anteckningen skrevs inte.",
    "versionStale": "Någon annan har rättat anteckningen medan du skrev. Din text står kvar här — läs om den nya versionen och skriv rättelsen mot den.",
    "retracted": "Anteckningen är markerad som felaktigt införd och kan inte rättas.",
    "clientMismatch": "Anteckningen skrevs inte på grund av ett tekniskt fel. Försök igen.",
    "noteNotFound": "Anteckningen finns inte längre att rätta.",
    "patientNotFound": "Patienten finns inte i journalen.",
    "unknown": "Anteckningen skrevs inte. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Anteckningen skrevs inte — låt fönstret vara öppet och försök igen.",
    "languageMissing": "Välj vilket språk anteckningen är skriven på. Anteckningen signerades inte."
  },
  "forensic": {
    "badge": "Rättsmedicinskt relevant",
    "mark": "Markera som rättsmedicinskt relevant",
    "marking": "Markerar …",
    "withdraw": "Ta bort markeringen",
    "withdrawing": "Tar bort …",
    "explanation": "Markeringen gör att anteckningen kan tas fram vid en senare utredning, till exempel om våld eller övergrepp. Den säger ingenting om vad som hänt.",
    "refused": "Markeringen kunde inte sparas. Översikten är uppdaterad — försök igen.",
    "unavailable": "Ingen kontakt med servern. Öppna patientöversikten igen och se om markeringen finns innan du försöker igen.",
    "confirmQuestion": "Ta bort markeringen? Borttagningen sparas i journalen med ditt namn, och markeringen finns kvar som en tidigare version.",
    "confirmWithdraw": "Ja, ta bort markeringen",
    "keep": "Behåll markeringen"
  }
}
